import styled from 'styled-components';

import { Clickable } from '../Clickable';

export const ToastWrapper = styled.div`
    color: #fff;
    font-size: ${({ theme }) => theme.fontSizes[4]};
`;

export const UndoButton = styled(Clickable)`
    font-weight: 700;
    margin-left: 3rem;
`;
